/**
 * @file MessageBs_knowledgeList.tsx
 * @description 展示“知识库/插件”溯源列表：支持横向滚动、点击预览图片或打开文件预览。
 * - 左右滚动按钮按需展示
 * - 图片使用 antd Image 预览，非图走文件预览组件
 */
import ScrollLeft from '@/assets/scroll-left.svg'
import PreviewPage from '@/pages/FileLibPage/components/preview'
import { useEffect, useRef, useState } from 'react'
import './styles.less'
import { knowledgeFileIsDeleted } from '@/controllers/API/knowledge'
/* 
知识库引用列表
detail: []
file_id: ""
knowledge_name: ""
title: "getWeatherInfo"
type: "plugin"
url: ""
*/
const MessageBs_knowledgeList = ({ list, title = '', badges = [] }) => {
  const scrollContainerRef = useRef(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  // 检查滚动状态
  const checkScrollStatus = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current
      setCanScrollLeft(scrollLeft > 0)
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth)
    }
  }
  // 初始化和滚动时检查状态
  useEffect(() => {
    checkScrollStatus()
  }, [list])

  // 上一个点击
  const handlePreClick = () => {
    if (scrollContainerRef.current && scrollContainerRef.current.scrollLeft > 0) {
      scrollContainerRef.current.scrollBy({
        left: -300, // 可调整滚动距离
        behavior: 'smooth'
      })
    }
  }

  /* 下一个next点击 */
  const handleNextClick = () => {
    if (
      scrollContainerRef.current.scrollLeft <
      scrollContainerRef.current.scrollWidth - scrollContainerRef.current.clientWidth
    ) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' }) // 每个元素的宽度加上右边距
    }
  }

  // 文件预览相关
  const [previewOpen, setPreviewOpen] = useState(false)
  const [curIndex, setCurIndex] = useState(0)
  const info = list[0]
  const handleClick = index => {
    setPreviewOpen(true)
    setCurIndex(index)
  }

  const fileList =
    list?.[0]?.trace_file_info?.filter(file => {
      return file.chunk_index_list.some(it => badges.includes(it))
    }) ?? []

  const cur_trace_file_info = fileList[curIndex]

  console.log('cur_trace_file_info', cur_trace_file_info)

  function isMarkdownFile(fileName) {
    if (!fileName) return false

    const markdownExtensions = ['.md']
    const lowerFileName = fileName.toLowerCase()

    return markdownExtensions.some(ext => lowerFileName.endsWith(ext))
  }

  return (
    <div className="flexCol MessageBs_knowledgeList_case w-[100%]">
      {title && !!fileList?.length && <span className="knowledge_title">引用知识库（{fileList?.length}）</span>}
      {/* 左滚动按钮 */}
      {canScrollLeft && <img src={ScrollLeft} alt="" className="knowledge_ScrollLeft" onClick={handlePreClick} />}
      {/* title存在 正常显示知识库 插件只有一个 显示在右下角 */}
      {title ? (
        <div className="knowledge_flowX w-[100%]" ref={scrollContainerRef} onScroll={checkScrollStatus}>
          {fileList.map((item: any, index) => {
            return (
              <div className="flexRow knowledge_flowX_cont" key={index}>
                <span className="domOverflowEllip_two cursonCase" onClick={() => handleClick(index)}>
                  {item.filename}
                </span>
              </div>
            )
          })}
        </div>
      ) : (
        <div className="flex w-full justify-end">
          <div className="text-xs text-gray-500">{list[0].title}</div>
        </div>
      )}
      {canScrollRight && (
        <svg
          className="knowledge_icon cursonCase"
          onClick={() => {
            handleNextClick()
          }}
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_ddd_6762_45052)">
            <circle cx="22" cy="22" r="12" fill="white" />
            <path
              d="M20 18L24 22L20 26"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <filter
              id="filter0_ddd_6762_45052"
              x="0"
              y="0"
              width="44"
              height="44"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow_6762_45052" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6762_45052" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2.5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_6762_45052" result="effect2_dropShadow_6762_45052" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
              <feBlend mode="normal" in2="effect2_dropShadow_6762_45052" result="effect3_dropShadow_6762_45052" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_6762_45052" result="shape" />
            </filter>
          </defs>
        </svg>
      )}

      {/* 展示溯源-预览 md格式直接预览 */}
      {previewOpen && (
        <PreviewPage
          open={previewOpen}
          fileInfo={{
            file_name: isMarkdownFile(cur_trace_file_info?.filename) ? cur_trace_file_info?.filename : 'xxxx.chunk_pdf',
            file_path: cur_trace_file_info?.url,
            object_name: cur_trace_file_info?.filename,
            id: cur_trace_file_info?.url
          }}
          setOpen={setPreviewOpen}
          knowledgeTraceInfo={{
            ...info,
            allHighlights: true,
            cur_trace_file_info,
            badges
          }} // 传递知识库溯源信息给PreviewPage
        />
      )}
    </div>
  )
}

export default MessageBs_knowledgeList
